import RadioGroup from 'components/elements/molecules/Radio/RadioGroup';
import RadioOption from 'components/elements/molecules/Radio/RadioOption';
import { getAppIds } from '../SyncCourses';

export default function CourseList({
  loading,
  courses,
  selectedCourse,
  onSelect,
  app,
}) {
  const appId = getAppIds(app).courseId;

  if (loading)
    return (
      <div
        className="fa fa-spin fa-spinner text-primary spinner"
        style={{ fontSize: '16px' }}
      />
    );

  return (
    <div>
      <RadioGroup
        handleChange={(event) => {
          const course = courses.find(
            (i) => String(i[appId]) === event.target.value,
          );
          onSelect(course);
        }}
      >
        <div className="filter-group">
          {courses.map((course, i) => (
            <div className="mr-2">
              <RadioOption
                id={`${course[appId]}-${i}`}
                name={course[appId]}
                value={course[appId]}
                label={course.name}
                checked={selectedCourse?.[appId] === course[appId]}
              />
            </div>
          ))}
        </div>
      </RadioGroup>
    </div>
  );
}
